import {Moment} from 'moment';
import {ICustomer} from './customer.model';
import {ITransaction} from "./transaction.model";

export interface ISalesCycle {
  id?: number;
  title?: string;
  startDate?: Moment;
  customer?: ICustomer;
  itemName?: string;
  level?: string;
  code?: string;
  address?: string;
  audience?: string;
  phone?: any;
  status?: string;
  status2?: string;
  add_auto_project?: any;
  step?: string;
  step_number?: any;
  floor_number?: string;
  number_of_units?: string;
  order_usage?: string;
  total_area?: string;
  construction_stage?: string;
  updateDate?: string;
  description?: string;
  createdDate?: any;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;
  isdeleted?: boolean;
  createdBy?: string;
  lastModifiedBy?: string;
  closed?: boolean;
  transactions?: ITransaction[];

}

export class SalesCycle implements ISalesCycle {
  constructor(public id?: number,
              public title?: string,
              public step?: string,
              public step_number?: any,
              public description?: string,
              public startDate?: Moment,
              public customer?: ICustomer,
              public createdBy?: string,
              public lastModifiedBy?: string,
              public closed?: boolean,
              public lastModifiedDate?: any,
              public created_date?: any,
              public transactions?: ITransaction[],
              public createdDate?: any) {
  }
}
